// todo: new message button as component
// todo: re-write 'new message' button logic using component's state

import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import ChatLogCGU from '../ChatLogCGU/index'
import ChatLogItem from '../ChatLogItem/index'
import UserListItemContextMenu from '../UserListItemContextMenu/index'
import UserInfoTooltip from '../UserInfoTooltip/index';

import Registry from '../../../registry/index';

import {openVideoWindow} from '../../../actions/streaming';

// webpack imports-loader is used here
import $ from 'jquery'
import {Scrollbars} from "react-custom-scrollbars";

require("imports-loader?jQuery=jquery!../../../3rdparty/fancybox2/jquery.fancybox.pack.js");
require("imports-loader?jQuery=jquery!../../../3rdparty/fancybox2/helpers/jquery.fancybox-thumbs.js");

class ChatLog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            autoScrollDownDisabled: this.props.browser.mobile
        };

        this.onScroll = this.onScroll.bind(this);
        this.onNewMessageClick = this.onNewMessageClick.bind(this);
        this.onAuthorMouseMove = this.onAuthorMouseMove.bind(this);
        this.showUserContextMenu = this.showUserContextMenu.bind(this);
    }

    onAttachmentClick() {
        var $this = $(this);

        if (!$this.attr("rel")) {
            var author = $this.parents(".message").find(".author").text();

            var $attachments = $this.parent().find("a.fancybox");
            $attachments.attr({rel: "fancybox_" + ( parseInt(Math.random() * 1000000000) ), title: author});
            $attachments.fancybox({
                type: "image",
                wrapCSS: "attachment",
                prevEffect: "none",
                nextEffect: "none",
                helpers: {
                    title: {
                        type: "outside"
                    },
                    thumbs: {
                        width: 72,
                        height: 72
                    },
                    overlay: {
                        css: {
                            /* background: "url('/css/chat-neo-design/images/fancybox_overlay.png')" */
                        }
                    }

                }
            });
            $this.trigger("click");

            return false;
        }

        return true;
    }

    componentDidMount() {
        $(document).delegate("a.fancybox", "click", this.onAttachmentClick);
        $(document).delegate(".fancybox-image", "contextmenu", function(event) { event.preventDefault(); });
        $(document).delegate("img.attachment", "contextmenu", function(event) { event.preventDefault(); });
    }

    componentWillUpdate(nextProps, nextState) {
        if (this.props.currentRoom.id &&
            nextProps.currentRoom.id &&
            this.props.currentRoom.id !== nextProps.currentRoom.id
        ) {
            $(".new-message-button").addClass("hidden");
        }

        if (nextState.tooltipUser) this.renderTooltip(nextState.tooltipUser, !!nextProps.watchingMe[nextState.tooltipUser.ufrag]);
    }

    componentDidUpdate(prevProps) {
        let prevMessages = prevProps.messages,
            messages =  this.props.messages;

        if (prevMessages.length && messages.length &&
            prevMessages[prevMessages.length-1].id !== messages[messages.length-1].id) {
                this.onNewMessageAdded();
        } else if (this.props.messages.length > prevProps.messages.length) {
            this.onNewMessageAdded();
        }
    }

    onNewMessageAdded() {
        const { autoScrollDownDisabled } = this.state;
        const { visible } = this.props;

        this.animateChatLog();

        let chatLogOverflow = this.chatLog.clientHeight > this.chatLogContainer.clientHeight;

        if ((autoScrollDownDisabled && chatLogOverflow) || (autoScrollDownDisabled && !visible)) {
            let $newMessageButton = $(".new-message-button");
            if ($newMessageButton.hasClass("hidden")) $newMessageButton.css("opacity", 0).removeClass("hidden").animate({opacity: 0.85}, 300, function() { this.style.opacity = ""; });
        }
    }
    
    animateChatLog(animationCB) {
//        let $chatLogContainer = $(this.chatLogContainer);

        if (!this.state.autoScrollDownDisabled) {
            this.scrollComponent.scrollToBottom();
/*
            let offset = this.chatLog.scrollHeight;

            if (offset < 0 || offset > $chatLogContainer.height()) {
                if (offset < 0)
                    offset = $chatLogContainer.scrollTop() + offset;
                $chatLogContainer.animate({scrollTop: offset}, 300, animationCB);
            }
 */
        }

    }

    onScroll(event) {
        let chatLogContainer = event.target;

        if (event.type === "scroll") {
            let bottomReached = (chatLogContainer.clientHeight + chatLogContainer.scrollTop > chatLogContainer.scrollHeight - 25);

            if (bottomReached) {
                this.setState({autoScrollDownDisabled: false});
                $(".new-message-button").addClass("hidden");
            } else {
                this.setState({autoScrollDownDisabled: true});
            }

            this.hideUserContextMenu();
        }

        return true;
    }

    onNewMessageClick(event) {
        var $button = $(event.target);
        const { newMessageBtnHandler } = this.props;

        this.setState({autoScrollDownDisabled: false}, function() {
            $button.animate({opacity: 0}, 300, function() { $button.addClass("hidden") });
            this.animateChatLog();
        });

        newMessageBtnHandler();

        return false;
    }

    showUserContextMenu(event, user) {
        let {currentUser, currentRoom, openVideoWindow} = this.props;

        UserListItemContextMenu.mount({
            user,
            currentUser,
            currentRoom,
            openVideoWindow,
            afterCloseFn: () => { this.toggleChatLogAnimation(true) },
            chatLog: true,
            ref: (r) => {
                this.contextMenu = r;

                this.contextMenu.setAnchor(event.target);
                this.contextMenu.position();
                this.contextMenu.open();

                this.toggleChatLogAnimation(false);
            }
        });

        // Reset selection on long-tap on nicknames on mobiles but keep selectability in general
        document.getSelection().empty();
    }

    hideUserContextMenu() {
        if (this.contextMenu) this.contextMenu.close();
    }

    toggleChatLogAnimation(enable) {
        this.setState({autoScrollDownDisabled: !enable})
    }

    onAuthorMouseMoveAfterTooltipRender(event, user, itemComponent) {
        let itemNode = ReactDOM.findDOMNode(itemComponent);
        let itemNodeBoundingClientRect = itemNode.getBoundingClientRect();

        let $popup = this.$popup;
        let popupWidth = $popup.outerWidth();
        let popupHeight = $popup.outerHeight();

        let target = event.toElement || event.target;
        if (!target) return false;

        let offsetLeft = 16, offsetTop = 16;

        // let baseTop = event.clientY,
        //     baseLeft = event.clientX;

        let baseTop = itemNodeBoundingClientRect.top,
            baseLeft = itemNodeBoundingClientRect.left;

        let bottomEdgeReached = baseTop + offsetTop + popupHeight > window.innerHeight,
            rightEdgeReached = baseLeft + offsetLeft + popupWidth > window.innerWidth;

        let top = bottomEdgeReached ? (window.innerHeight - popupHeight - offsetTop) : (baseTop + offsetTop),
            left = baseLeft - popupWidth + offsetLeft;

        if (event.type == "mouseenter") {
            this.setState({tooltipUser: user});

            this.tooltipPopup.open();

            $popup.css({
                left: left+"px",
                top: top+"px"
            }).removeClass("hidden").addClass("shown");

            return true;
        }

        if (event.type == "mousemove") {
            $popup.data("keep-visible", true);

            $popup.css({
                left: left+"px",
                top: top+"px"
            });

            return true;
        }

        if (event.type === "mouseleave") {
            this.setState({tooltipUser: null});

            $popup.data("keep-visible", false);
            var timeout = setTimeout(function() {
                if (!$popup.data("keep-visible")) {
                    $popup.removeClass("shown").addClass("hidden").css({left: "", top: ""});
                }
            }, 50);

            return true;
        }
    }

    onAuthorMouseMove(event, user, itemComponent) {
        let isWatchingMe = !!this.props.watchingMe[user.ufrag];

        if (!this.$popup) {
            this.renderTooltip(user, isWatchingMe, () => this.onAuthorMouseMoveAfterTooltipRender(event, user, itemComponent) );
        } else {
            this.onAuthorMouseMoveAfterTooltipRender(event, user, itemComponent)
        }

        return true;
    }

    renderTooltip(user, watchingMe, onMount) {
        const { currentUser } = this.props;

        UserInfoTooltip.mount({
            user,
            watchingMe,
            currentUser,
            ref: (r) => {
                this.tooltipPopup = r;
                this.$popup = $(r._ref);
                if (onMount) onMount();
            }
        });
    }

    render() {
        let lang = Registry.get('locale'),
            mainRoomId = Registry.get('chatInterface').getDefaultRoomId();

        let {messages, currentUser, currentRoom, currentRoomInfo, browser, openVideoWindow} = this.props;

        let isMainRoom = this.props.roomid === mainRoomId;

        let authorEventRelatedProps = {};
        if (browser.desktop) {
            authorEventRelatedProps = {
                onAuthorMouseEnter: this.onAuthorMouseMove,
                onAuthorMouseMove: this.onAuthorMouseMove,
                onAuthorMouseLeave: this.onAuthorMouseMove,
            }
        }

        return (
            <div className="top-chat">
                <div
                    ref={(chatLogContainer) => this.chatLogContainer = chatLogContainer}
                    className='block-chat-text'
                >
                    <Scrollbars
                        className="scrollbars"
                        renderTrackVertical={props => <div {...props} className="track-vertical"/>}
                        renderThumbVertical={props => <div {...props} className="thumb-vertical"/>}
                        ref={c => { this.scrollComponent = c }}
                        onScroll={this.onScroll}
                    >
                        <div className="block-chat-text-messages" ref={(chatLog) => this.chatLog = chatLog}>
                            {isMainRoom ? <ChatLogCGU browser={browser} /> : <div className="spaceholder"></div>}
                            {messages.map(message =>
                                <ChatLogItem key={message.id}
                                             type={message.type}
                                             message={message.message}
                                             currentUser={currentUser}
                                             isMainRoom={isMainRoom}
                                             currentRoomInfo={currentRoomInfo}
                                             user={message.user}
                                             mentionUsers={message.mentionUsers}
                                             showUserContextMenu={this.showUserContextMenu}
                                             openVideoWindow={openVideoWindow}
                                             {...authorEventRelatedProps}
                                />
                            )}
                        </div>
                    </Scrollbars>
                </div>
                <a className="new-message-button hidden" href="#" onClick={this.onNewMessageClick}>{lang.new_message}</a>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    //console.log(ownProps);
    //let roomMessages = state.roomMessages;
    let roomMessages = [];
    if (state.rooms[ownProps.roomid]) {
        roomMessages = state.rooms[ownProps.roomid].messages;
    }
    let displayLimit = 500;
    return {
        messages: roomMessages,
        currentUser: state.currentUser,
        currentRoom: state.currentRoom,
        currentRoomInfo: state.rooms[ownProps.roomid].info,
        browser: state.browser,
        watchingMe: state.watchingMe,
    }
}

let mapDispatchToProps = {
    openVideoWindow: openVideoWindow
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatLog);


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatLog/index.js